import products from 'public/products.json';

export default function (type: ItemTypeT, name: ItemNameT): ItemI {
  return (products[type] as unknown as Record<ItemNameT, ItemI>)?.[name];
}
